import * as cn from "./Demand.scss"
import {User} from "./../model/User"
import {employeeYear, SummaryRow, traineeDemandColumns} from "./Final"
import {Demand as DemandModel, DemandByYear, DemandList} from "../model/Demand";
import {getCompany, getSpeciality, getUniversityBranch} from "../model/utils/utils";
import {Divisions} from "../model/Division";
import {Specialities, Speciality} from "../model/Speciality";
import {UniversityBranch, UniversityBranches} from "../model/UniversityBranch";
import {EMPLOYEE_YEAR, TRAINEE_DEMAND_YEARS} from "../Demand/common";
import * as React from "react";
import {Footer} from "./Footer";
import {Trainee} from "../model/Trainee";

export enum Type {
    Demand,
    Target,
}

type Props = {
    demand: DemandList
    divisions: Divisions
    specialities: Specialities
    universityBranches: UniversityBranches
    user: User
    company: string
    total: SummaryRow
    totalNuclear: SummaryRow
    totalAesProjects: SummaryRow
    order: number
}

type RowProps = {
    traineeCurrentYear: number
    traineeDemandByYear: DemandByYear
    speciality: Speciality
    universityBranch: UniversityBranch
    company: {
        company: string
    }
}

export class Row extends React.PureComponent<RowProps> {
    render() {
        const {
            traineeCurrentYear,
            traineeDemandByYear,
            speciality: {
                title: speciality,
                category,
                code,
            },
            universityBranch: {
                abbreviation: university,
            },
            company: {
                company,
            },
        } = this.props

        return (
            <tr className={cn.row}>
                <td className={cn.cell}>{company}</td>
                <td className={cn.cell}>{category}</td>
                <td className={cn.cell}>{code + " — " + speciality}</td>
                <td className={cn.cell}>{traineeCurrentYear || ""}</td>
                {traineeDemandColumns.map(year => <td {...{key: year}}
                                                      className={cn.cell}>{traineeDemandByYear[year] || ""}</td>)}
                <td className={cn.cell + " " + cn.cellUniversity}>{university}</td>
            </tr>
        )
    }
}

export class TraineeDemand extends React.PureComponent<Props> {
    render() {
        const {order, demand, company, user, divisions, specialities, universityBranches, total, totalNuclear, totalAesProjects} = this.props

        return (
            <div className = {cn.component}>
                <div className = {cn.page}>
                    <br/>
                    <div className = {cn.heading}>
                        <div className = {cn.title}>
                            Данные о трудоустройстве и потребностях организации Госкорпорации «Росатом»
                            <br/>
                            в трудоустройстве студентов образовательных организаций
                            <br/>
                            Приложение № {order}
                        </div>
                        <div className = {cn.meta}>
                            <div className = {cn.label}>Организация:</div><div className = {cn.value}>{company}</div>
                        </div>
                        <div className = {cn.meta}>
                            <div className = {cn.label}>Дата заполнения:</div>
                            <div className = {cn.value}>
                                {("0" + new Date().getDate()).slice(-2) + "." + ("0"+(new Date().getMonth()+1)).slice(-2) + "." + new Date().getFullYear()}
                            </div>
                        </div>
{/*
                        <div className = {cn.meta}>
                            <div className = {cn.label}>Ответственный:</div><div className = {cn.value}>{user.executor.fullName}</div>
                        </div>
*/}
                    </div>
                    <br/>
                    <br/>
                    <table className = {cn.table} cellPadding = {0} cellSpacing = {0}>
                        <colgroup>
                            {Array.apply(null, Array(traineeDemandColumns.length + 5)).map((value, key, array) => (
                                <col {...{key}} className = {cn.column + (key === array.length - 1 ? " " + cn.columnUniversity : "")}/>)
                            )}
                        </colgroup>
                        <thead className = {cn.head}>
                        <tr className={cn.headRow}>
                            <td className={cn.headCell} rowSpan={2}>Предприятие</td>
                            <td className={cn.headCell} rowSpan={2}>УО</td>
                            <td className={cn.headCell} rowSpan={2}>Направление подготовки/Специальность</td>
                            <td className={cn.headCell} colSpan={1}>Факт</td>
                            <td className={cn.headCell} colSpan={1}>План</td>
                            <td className={cn.headCell} colSpan={TRAINEE_DEMAND_YEARS.length - 1}>Прогноз</td>
                            <td className={cn.headCell} rowSpan={2}>Образовательная организация</td>
                        </tr>
                        <tr className={cn.headRow}>
                            <td className={cn.headCell}>{EMPLOYEE_YEAR - 2000}</td>
                            {traineeDemandColumns.map(year => <td className={cn.headCell}
                                                                  key={year}>{year - 2000}</td>)}
                        </tr>
                        </thead>
                        <tbody>
                        {demand.map((demand: DemandModel) => {
                            const traineeCurrentYear = demand.trainees.filter((student: Trainee) => student.demandYear === EMPLOYEE_YEAR).reduce((r: number, {demand}: Trainee) => r + (demand || 0), 0)

                            if (demand.isPracticePaid && (demand.traineeDemandTotal || traineeCurrentYear)) {

                                return <Row {...{
                                    key: demand.id,
                                    traineeCurrentYear,
                                    traineeDemandByYear: demand.traineeDemandByYear,
                                    company: getCompany(divisions, demand.companyId),
                                    speciality: getSpeciality(specialities, demand.specialityId),
                                    universityBranch: getUniversityBranch(universityBranches, demand.universityBranchId),
                                }}/>
                            }
                        }).toList()}
                        <tr className={cn.rowTotal}>
                            <td className={cn.cellTotal}>Итого:</td>
                            <td className={cn.cellTotal}/>
                            <td className={cn.cellTotal}/>
                            <td className={cn.cellTotal}>{total[employeeYear] || ""}</td>
                            {traineeDemandColumns.map(year => <td {...{key: year}}
                                                                  className={cn.cellTotal}>{total[year] || 0}</td>)}
                            <td className={cn.cellTotal + " " + cn.cellTotalUniversity}/>
                        </tr>
                        <tr className={cn.rowTotal}>
                            <td className={cn.cellTotal}>в т.ч. по ядерным специальностям:</td>
                            <td className={cn.cellTotal}/>
                            <td className={cn.cellTotal}/>
                            <td className = {cn.cellTotal}>{totalNuclear[employeeYear] || ""}</td>

                            {traineeDemandColumns.map(year => <td {...{key: year}}
                                                                  className={cn.cellTotal}>{totalNuclear[year] || 0}</td>)}
                            <td className={cn.cellTotal + " " + cn.cellTotalUniversity}/>
                        </tr>
                        {/*
                        <tr className = {cn.rowTotal}>
                            <td className = {cn.cellTotal}>в т.ч. по проектам сооружения АЭС:</td>
                            <td className = {cn.cellTotal}/>
                            <td className = {cn.cellTotal}/>
                            {traineeDemandColumns.map(year => <td {...{key: year}} className = {cn.cellTotal}>{totalAesProjects[year] || 0}</td>)}
                            <td className = {cn.cellTotal + " " + cn.cellTotalUniversity}/>
                        </tr>
*/}
                        </tbody>
                    </table>
                </div>
                <Footer user={user}/>
            </div>
        )
    }
}